<template>
  <div>
    <d-form-row class="border mb-3">
      <table class="table mb-0 table-striped">
        <thead class="bg-light">
          <tr>
            <th colspan="4">
              <h6 class="mb-0">Borracha</h6>
            </th>
          </tr>
          <tr>
            <th scope="col" class="border-0">Kilos</th>
            <th scope="col" class="border-0">Anos de garantia</th>
            <th scope="col" class="border-0">Tipo</th>
            <th scope="col" class="border-0">Opções</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(col, index) in model.rubber" :key="index">
            <td>
              <d-input type="number" v-model="col.kilo" placeholder="Kg" />
            </td>
            <td>
              <d-input type="number" v-model="col.warranty" placeholder="Garantia" />
            </td>
            <td>
              <d-select v-model="col.type">
                <option :value="option.slug" v-for="option in grassTypes" :key="option.slug">
                  {{ option.name }}
                </option>
              </d-select>
            </td>
            <td cols class="text-right text-semibold">
              <i class="fas fa-plus text-success" @click="addRow('rubber')" v-if="index + 1 == model.rubber.length"></i>
              <i class="fas fa-minus text-danger ml-2" @click="removeRow('rubber', value)"></i>
            </td>
          </tr>
        </tbody>
      </table>
    </d-form-row>
    <d-form-row class="border mb-3">
      <table class="table mb-0 table-striped">
        <thead class="bg-light">
          <tr>
            <th colspan="4">
              <h6 class="mb-0">Iluminação</h6>
            </th>
          </tr>
          <tr>
            <th scope="col" class="border-0">Min (M²)</th>
            <th scope="col" class="border-0">Max (M²)</th>
            <th scope="col" class="border-0">Conjuntos</th>
            <th scope="col" class="border-0">Opções</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(col, index) in model.illumination" :key="index">
            <td>
              <d-input type="number" v-model="col.min" placeholder="Min" />
            </td>
            <td>
              <d-input type="number" v-model="col.max" placeholder="Max" />
            </td>
            <td>
              <d-input type="number" v-model="col.conjuntos" placeholder="Conjuntos" />
            </td>
            <td cols class="text-right text-semibold">
              <i class="fas fa-plus text-success" @click="addRow('illumination')" v-if="index + 1 == model.illumination.length"></i>
              <i class="fas fa-minus text-danger ml-2" @click="removeRow('illumination', index)"></i>
            </td>
          </tr>
        </tbody>
      </table>
    </d-form-row>
  </div>
</template>

<script>
import { GRASS_TYPE, ROW_ILLUMINATION, ROW_RUBBER } from '../SettingsModel';

export default {
  name: 'Quotation-tab',
  props: {
    quotation: {
      type: Object,
      require: true,
    },
  },
  data() {
    return {
      grassTypes: GRASS_TYPE,
      defaultRow: { rubber: ROW_RUBBER, illuminarion: ROW_ILLUMINATION },
    };
  },
  computed: {
    model: {
      get() {
        return this.quotation;
      },
      set(value) {
        this.$emit('update:quotation', value);
      },
    },
  },
  methods: {
    addRow(list) {
      this.model[list].push({ ...this.defaultRow[list] });
    },
    checkEmptyOptions(list) {
      if (this[list].length === 0) {
        this[list].push({ ...this.defaultRow[list] });
      }
    },
    removeRow(list, index) {
      this.model[list].splice(index, 1);
      this.checkEmptyOptions(list);
    },
  },
};
</script>

<style lang="scss" scoped>
.tab-pane {
  border: 1px solid #e1e5eb;
  border-top: 0;
}
</style>
